module.exports = __webpack_public_path__ + "assets/img/34_781_big.5d98b2d7.jpg";